export const RTD_GAME_PROGRAM_ID="ES5z7j4dmZji1oiSkUPEHcPiHbEjPxSyHcNnny8HjZdJ"
